<template>
    <header>
        <a href="http://www.bactistatin.com/about/" target="_blank" class="logo logo__left" @click = "gaLogoClick">
            <!--<LogoLeft></LogoLeft>-->
            <img src="/static/images/logo-b2.png" alt="baktistatin">
            <div class="logo-text mobile-hidden">
                <!--<span>Улучшает&nbsp;функциональное<br> состояние&nbsp;ЖКТ&nbsp;при:</span>-->
                <!--<ul>-->
                    <!--<li>Смене&nbsp;характера&nbsp;питания</li>-->
                    <!--<li>Приеме&nbsp;непривычной&nbsp;пищи</li>-->
                <!--</ul>-->
                <!--<span class="small">Взрослым и детям от 6 лет!</span>-->
                <!--<Arrow></Arrow>-->

                <span>БАКТИСТАТИН ® представитель нового поколения пробиотиков – метабиотик* </span>
            </div>
        </a>
        <a href="https://eda.ru/" class="logo logo__right" target="_blank" @click = "gaLogoClick">
            <span>спецпроект</span>
            <img src="/static/images/icons/eda.png" alt="Eda Logo">
        </a>
    </header>
</template>

<script>
    import LogoLeft from '../../assets/svg/logo.svg';
    import Arrow from '../../assets/svg/arrow.svg';

    export default {
        name: 'Header',
        components: {
            LogoLeft,
            Arrow
        },
        methods: {
            gaLogoClick(){
                ga('send', 'event', 'redirect', 'show', 'Redirect from Logo to: ' + event.currentTarget.getAttribute('href'));
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Header.vue?422863f0